var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoard = function SvgBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5H3.75a.75.75 0 0 0-.75.75V19.5A1.5 1.5 0 0 0 4.5 21h3.75a1.5 1.5 0 0 0 1.5-1.5V15h4.5v1.5a1.5 1.5 0 0 0 1.5 1.5h3.75a1.5 1.5 0 0 0 1.5-1.5V5.25a.75.75 0 0 0-.75-.75m-12 15H4.5V12h3.75zm0-9H4.5V6h3.75zm6 3h-4.5V6h4.5zm5.25 3h-3.75V12h3.75zm0-6h-3.75V6h3.75z"
  })));
};
export default SvgBoard;